import React, { useSyncExternalStore } from "react";
import Icon from "../Icon";
import {
    getOverdueAlertLevel,
    subscribeOverdueAlert,
    OVERDUE_ALERT_WARNING,
    OVERDUE_ALERT_CRITICAL
} from "../../services/overdueAlert";

const SUPPORT_WHATSAPP = "https://wa.me/message/EMWTM66MIMWED1";

const MESSAGES = {
    [OVERDUE_ALERT_WARNING]: {
        icon: "alert",
        title: "Ops! Não identificamos o pagamento da sua mensalidade",
        text: "Entre em contato conosco para enviar o comprovante e agilizar a baixa. E se precisar da 2ª via, estamos aqui para te ajudar. 😊",
        action: "Falar com a gente"
    },
    [OVERDUE_ALERT_CRITICAL]: {
        icon: "octagon-alert",
        title: "Evite o bloqueio da sua conta",
        text: "Sua mensalidade segue em aberto. O acesso à plataforma e ao seu site pode ser bloqueado a qualquer momento. 😱 Regularize hoje!",
        action: "Regularizar agora"
    }
};

export const SuspensionAlert = () => {
    // Reage a qualquer resposta da API, não só ao login: a inadimplência começa
    // e termina no meio da sessão.
    const level = useSyncExternalStore(subscribeOverdueAlert, getOverdueAlertLevel);
    const message = MESSAGES[level];

    if (!message) return null;

    return (
        <div className={`box-alert-count box-alert-count--${level}`}>
            <div className="content-box-alert">
                <Icon name={message.icon} size={24} />
                <div>
                    <p><strong>{message.title}</strong></p>
                    <p>{message.text}</p>
                </div>
            </div>
            <a href={SUPPORT_WHATSAPP} target="_blank" rel="noreferrer">{message.action}</a>
        </div>
    );
}

export default SuspensionAlert;
